import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue";
const _hoisted_1 = { class: "h-full w-full" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-chevron-down ml-2" }, null, -1);
const _hoisted_3 = { class: "block origin-top-right absolute left-auto right-3 shadow-lg cursor-pointer bg-gray-100 z-10 mt-2" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "flex flex-row justify-center items-center" };
export function render(_ctx, _cache) {
    const _directive_click_outside = _resolveDirective("click-outside");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["hover:bg-gray-100 cursor-pointer p-2 flex flex-row justify-center items-center uppercase", {
                    'bg-gray-100': _ctx.dropDownOpen,
                }]),
            ref: "workSpaceDropdown",
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.dropDownOpen = !_ctx.dropDownOpen))
        }, [
            _createTextVNode(_toDisplayString(_ctx.getLanguage()), 1),
            _hoisted_2
        ], 2)), [
            [_directive_click_outside, _ctx.closeDropdown]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language) => {
                return (_openBlock(), _createElementBlock("a", {
                    key: language.shorthand,
                    class: "block px-4 py-2 text-sm text-primary hover:bg-gray-200 hover:text-gray-900",
                    onClick: ($event) => (_ctx.setLang(language.shorthand))
                }, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(language.longhand), 1)
                ], 8, _hoisted_4));
            }), 128))
        ], 512), [
            [_vShow, _ctx.dropDownOpen]
        ])
    ]));
}
